import type { IDisclaimer } from './types';

export const DEFAULT_DISCLAIMER: IDisclaimer[] = [
  {
    id: 1,
    text:
      'Сервис Sravni.ru бесплатно предоставляет информацию о займах. Процентные ставки и срок погашения займа могут отличаться, т.к. зависят от выбранной вами микрофинансовой организации (МФО). Ставки по займам могут составлять от 0% до 0,8% в день (максимальный процент по займу составит 292% годовых). Срок у данных займов может быть от 61 дня до 365 дней. Это означает, что минимальный срок погашения займа: 61 день. Максимальный срок погашения займа: 365 дней.',
  },
  {
    id: 2,
    text:
      'Пример расчета по займу на сумму 10 000 рублей сроком на 10 недель, т.е. на 70 дней, по ставке 0,75% в день - сумма процентов за весь период составит 5 250 рублей. Общая выплата будет равна 15 250 рублей.',
  },
  {
    id: 3,
    text:
      'При несоблюдении выплат в срок, предусмотренный в договоре, появляется штраф за просрочку займа. Проценты за пользование суммой займа при нарушении срока возврата займа и начисленных процентов на 10 дней (10% от суммы займа) – 1 000 рублей. Пеня на сумму займа в размере 20% годовых от суммы займа начисляется за просрочку возврата займа на 10 дней составит 51,7 рублей. Сумма к возврату при нарушении срока возврата займа и начисленных процентов на 10 дней: 15 250 + 1 000 + 51,7 = 16 301,7 рублей.',
  },
  {
    id: 4,
    text:
      'Информация о займах не является офертой или публичной офертой: конечные условия для выдачи конкретного займа определяются на сайте конкретного МФО в индивидуальном порядке.',
  },
  {
    id: 5,
    text:
      'Наши основные партнеры среди МФО: ООО МФК «Вэббанкир» (Рег.&nbsp;№ 2120177002077), ООО МФК «Мани Мен» (Рег.&nbsp;№ 2110177000478), ООО МФК «Займер» (Рег.&nbsp;№ 651303532004088), ООО МКК «КапиталЪ-НТ» (Рег.&nbsp;№ 001603465007766), ООО МКК «Русинтерфинанс» (Рег.&nbsp;№ 2120754001243).',
  },
];

export const GURULEADS_DISCLAIMER: IDisclaimer[] = [
  {
    id: 1,
    text:
      'Условия предоставления займов потребителю. Микрозаймы предоставляются на сумму от 2 000 до 100 000 рублей. Минимальный срок погашения займа 93 дня, максимальный срок погашения займа 365 дней. Годовая процентная ставка (в том числе со скидкой) определяется в размере от 0% до 365% с учетом скидок.',
  },
  {
    id: 2,
    text:
      'Требования к заемщику. Возраст от 18 до 75 лет, постоянная прописка в любом регионе РФ, любая кредитная история.',
  },
  {
    id: 3,
    text:
      'Условия получения. Первый заём до 10 000 рублей выдается по ставке 0% в случае своевременного погашения. Процентная ставка по займам от 30 до 360% годовых, по потребительским кредитам и кредитным картам - от 17 до 31% годовых. В случае нарушения сроков, размер неустойки составляет 0,10% от суммы просрочки в день, но не более 10% от суммы кредита. В случае длительной задержки выплаты информация будет передана в БКИ.',
  },
  {
    id: 4,
    text: 'Комиссия за выдачу займа отсутствует. Общие дополнительные комиссии отсутствуют.',
  },
  {
    id: 5,
    text:
      'Ответственность потребителя в случае просрочки займа. В том случае, если тело займа и комиссия не выплачены в установленный срок, вам будет начислена неустойка согласно договору. Сумму неустойки уточняйте у выбранного вами кредитора.',
  },
  {
    id: 6,
    text:
      'Процедура взыскания долга. Кредитор имеет право прибегнуть к услугам коллекторских компаний и судебным инстанциям.',
  },
  {
    id: 7,
    text:
      'Влияние просрочки на вашу кредитную историю. Данные о просрочке займа могут быть переданы в кредитное бюро, что в дальнейшем может негативно повлиять на вашу кредитную историю. Будьте бдительны!',
  },
  {
    id: 8,
    text:
      'Пример расчета стоимости займа. Сумма займа: 9000 руб. Дневная процентная ставка: 1%. Период, на который оформляется займ: 65 дней. Плата за пользование кредита составляет 90 рублей согласно дневной процентной ставке. Итого, необходимо вернуть: 9000 руб + (90 руб * 65 дней) = 14850 руб(тело кредита + проценты). Сервис бесплатный - за предоставление информации комиссия не взымается. Мы постоянно мониторим самые последние предложения от МФО, и актуализируем наиболее выгодные из них!',
  },
  {
    id: 9,
    text:
      'Лицензии МФО, представленных на сайте. Moneyman - ООО МФК «Мани Мен» Лицензия ЦБ РФ: 2110177000478 Юридический адрес: 121096, Москва, ул. Василисы Кожиной, д.1, офис Д13. Планета Кэш - ООО «МКК «Планета Кэш» Лицензия ЦБ РФ: 1803140008702. GreenMoney ООО МФК "ГринМани" Лицензия ЦБ РФ: 2120742002054 650000, Кемеровская область, Кемерово, улица 50 лет Октября, дом 11, помещение 7. Zaymigo - ООО «Займиго МФК» Лицензия ЦБ РФ:651303322004222 Адрес: 603093, Нижегородская область, г. Нижний Новгород, ул. Ковровская, д. 21А, пом. 603. ВебЗайм - ООО МКК «ВЕБ-ЗАЙМ» Лицензия ЦБ РФ: 2110827000326 Адрес: 630099, Новосибирская область, г. Новосибирск, ул. Депутатская, д. 2, оф. 60. Lime - ООО МФК «Лайм-Займ» Лицензия ЦБ РФ: 651303045004102 Адрес: 630102, Россия, Новосибирск ул. Кирова 48, офис 1401. Webbankir ООО МФК «ВЭББАНКИР» Лицензия ЦБ РФ: 2120177002077 Адрес: 125466, г. Москва, ул. Соколово-Мещерская, д. 29, оф. 308. Turbozaim ООО МФК «Турбозайм» Лицензия ЦБ РФ: 651303045003951 Адрес: 123290, г.Москва, Магистральный 1-й туп., д.11, стр.10, пом.1, эт.1. ЗАЙМЕР - ООО МФК «Займер» Лицензия ЦБ РФ: 651303532004088 Адрес: 630099, Новосибирская область, г. Новосибирск, ул. Октябрьская Магистраль, д. 3, оф. 906.',
  },
];

export const KZ_DISCLAIMER: IDisclaimer[] = [
  {
    id: 1,
    text:
      'На данной странице представлена информация о финансовых услугах, предоставляемых на территории Республики Казахстан.',
  },
  {
    id: 2,
    text: 'Информация о полной стоимости кредита и примере расчета',
    isTitle: true,
  },
  {
    id: 3,
    text:
      'Если вы взяли кредит на сумму 1000 тенге на 90 дней с процентной ставкой 0,01% в день, то плата за пользование средствами составит 0,01% в день, то есть 0,1 тенге в день. Выходит, вы возвращаете сумму процентов равную 9 ₸, то есть 0.1 ₸ * 90 дней и сумму взятого кредита, равную 1 000 ₸. Таким образом, общая сумма возврата состоит из суммы кредита и суммы начисленных процентов и равняется 1009 ₸. Минимальный и максимальный период погашения долга составляет от 65 дней до 365 дней. Максимальная годовая процентная ставка, включающая ссудный процент, а также все остальные комиссии и расходы за год, или аналогичная ставка, рассчитанная в соответствии с местным законодательством, составляет 31% годовых.',
  },
  {
    id: 4,
    text: 'Последствия не выплаты заемных средств',
    isTitle: true,
  },
  {
    id: 5,
    text:
      'Если заемщик не уплачивает кредитной организации сумму кредита и проценты за пользование кредитом в оговоренный срок, кредитная организация начисляет неустойку за просрочку выплаты по кредиту. Обычно кредитные организации предоставляют дополнительно 3 рабочих дня, чтобы заемщик смог внести очередной платеж, или выплатить сумму кредита полностью, на случай непредвиденной задержки, связанной с безналичным переводом средств. Если кредитная организация не получает оговоренный в договоре платеж в срок, она связывается с заемщиком и напоминает о последствиях, наступающих при неуплате. Если долго не удается связаться с заемщиком и платежи по кредиту не поступают, кредитная организация начислит денежный штраф, размер которого обычно равен 0,1% от суммы кредита за каждый день просрочки, точный размер штрафов за просрочку следует уточнять при подписании договора на предоставление кредитных услуг.',
  },
];
